import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeHeading02, typeHeading03, typeHeading04, typeBody02, typeLabel01, typeBody03 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { spacer, unit, pixelate, margin, SIZE, mediaQuery } from '../../theme/metrics'

import { StyledLink, StyledButton } from '../../theme/components'

export const Inner = styled.div`
	${row({medium:true})}

	${mediaQuery[SIZE.medium]}{
		justify-content: flex-end;
	}
`

export const CategoriesContainer = styled.div`
	${props => column({medium:{span:8}},{direction:props.theme.direction})}
	margin-bottom: ${spacer(1)};
	display: flex;
	
	${mediaQuery[SIZE.medium]}{
		
		margin-bottom: 0;
	}
`

export const SummaryContainer = styled.div`
	${props => column({medium:{span:8}},{direction:props.theme.direction})}
	margin-bottom: ${spacer(1)};

	${mediaQuery[SIZE.medium]}{
		display: flex;
		align-items: center;
		margin-bottom: 0;
	}
`

export const SummaryText = styled.p`
	${typeBody02}
	color: ${props => props.theme.foreground};
`

export const SearchContainer = styled.form`
	${props => column({medium:{span:4}},{direction:props.theme.direction})}
	display: flex;
`

export const CategoriesList = styled.ul`
	display: flex;
	flex-wrap: wrap;
	margin-bottom: ${unit(-2)};
	align-items: center;

	${mediaQuery[SIZE.medium]}{
		flex-direction: row;
		margin-bottom: 0;
	}
`

export const CategoriesListItem = styled.li`
	margin-right: ${unit(2)};
	margin-bottom: ${unit(2)};

	&:last-child{
		margin-right: 0;
	}

	${mediaQuery[SIZE.medium]}{
		margin-right: ${unit(3)};
		margin-bottom: 0;
	}
`

export const CategoryLink = styled(StyledLink)`
	
`

export const SearchInput = styled.input`
	${typeBody02}
	color: ${props => props.theme.foreground};
	background-color: ${props => props.theme.shadow};
	padding: 0 ${unit(3)};
	text-decoration: none;
	display: block;
	outline: none;
	border: none;
	white-space: nowrap;
	line-height: ${unit(6)};
	height: ${unit(6)};
	width: 0;
	flex: 1 1 auto;
`

export const SearchButton = styled(StyledButton)`
	
`